import { ContextMenu, ContextMenuButton } from './index';
import React from 'react';
import { ContextMenuButtonProps } from './partials/ContextMenuButton';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export function CommonContextMenu({
  toolTip,
  actions,
  toolTipPlacement,
}: {
  toolTip: string;
  toolTipPlacement?: TooltipPlacement;
  actions: ContextMenuButtonProps[];
}) {
  return (
    <ContextMenu tooltipText={toolTip} tooltipPlacement={toolTipPlacement}>
      {actions.map(action => (
        <ContextMenuButton {...action} key={action.key} />
      ))}
    </ContextMenu>
  );
}
